import { render, staticRenderFns } from "./vList.vue?vue&type=template&id=49227938&scoped=true&"
import script from "./vList.vue?vue&type=script&lang=js&"
export * from "./vList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49227938",
  null
  
)

export default component.exports